import React from "react";

function MainImg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 465 317"
        >
            <path
                fill="#ECF5FF"
                fillRule="evenodd"
                d="M119.215 76.674c16.769 0 32.721 3.468 47.197 9.712C192.406 35.13 245.611 0 307.026 0c87.021 0 157.565 70.522 157.565 157.516 0 86.993-70.544 157.513-157.565 157.513H119.215C53.373 315.029 0 261.67 0 195.851 0 130.033 53.373 76.674 119.215 76.674z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#95C3FF"
                fillRule="evenodd"
                d="M285.433 48.91h118.474c2.58 0 4.691 2.11 4.691 4.69v160.807a4.704 4.704 0 01-4.691 4.689H285.433a4.704 4.704 0 01-4.691-4.689V53.597c0-2.58 2.111-4.69 4.691-4.69"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M404.717 51.978H284.619v164.047h120.098V51.978z"
            ></path>
            <path
                fill="#538ACE"
                fillRule="evenodd"
                d="M322.576 107.781h22.832c.762 0 1.384.622 1.384 1.383 0 .762-.622 1.384-1.384 1.384h-22.832a1.387 1.387 0 01-1.384-1.384c0-.761.622-1.383 1.384-1.383z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#538ACE"
                d="M344.84 31.504a3.347 3.347 0 11.002 6.693 3.347 3.347 0 01-.002-6.693zM309.548 56.49h70.582v-2.79c0-5.42-5.215-8.369-11.085-8.369h-7.85v-1.294a4.604 4.604 0 00-4.592-4.591h-3.333v-2.906c0-4.638-3.794-8.43-8.432-8.43-4.639 0-8.433 3.792-8.433 8.43v2.906h-3.333a4.606 4.606 0 00-4.592 4.591v1.294h-7.928c-8.421 0-11.007 4.383-11.007 8.369v2.79h.003z"
            ></path>
            <path
                fill="#B7D5FF"
                fillRule="evenodd"
                d="M322.576 115.07h69.23c.761 0 1.384.622 1.384 1.384 0 .761-.623 1.383-1.384 1.383h-69.23a1.387 1.387 0 01-1.384-1.383c0-.762.622-1.384 1.384-1.384zM322.576 122.356h69.23c.761 0 1.384.622 1.384 1.384 0 .761-.623 1.383-1.384 1.383h-69.23a1.387 1.387 0 01-1.384-1.383c0-.762.622-1.384 1.384-1.384zM322.576 140.147h68.966a1.39 1.39 0 011.387 1.384c0 .761-.623 1.384-1.387 1.384h-68.966a1.388 1.388 0 01-1.384-1.384c0-.761.622-1.384 1.384-1.384zM322.576 147.436h68.966a1.39 1.39 0 011.387 1.384c0 .761-.623 1.384-1.387 1.384h-68.966a1.388 1.388 0 01-1.384-1.384c0-.761.622-1.384 1.384-1.384zM297.068 187.911h40.936c.761 0 1.384.622 1.384 1.383 0 .762-.623 1.384-1.384 1.384h-40.936a1.388 1.388 0 01-1.385-1.384c0-.761.623-1.383 1.385-1.383zM296.917 195.2h67.492c.762 0 1.385.622 1.385 1.383 0 .762-.623 1.384-1.385 1.384h-67.492a1.387 1.387 0 01-1.384-1.384c0-.761.622-1.383 1.384-1.383z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#95C3FF"
                fillRule="evenodd"
                d="M295.712 68.484h98.613c.692 0 1.256.565 1.256 1.257v25.862c0 .691-.564 1.256-1.256 1.256h-98.613a1.259 1.259 0 01-1.256-1.256V69.74c0-.692.564-1.257 1.256-1.257z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#B7D5FF"
                fillRule="evenodd"
                d="M322.576 158.512h29.651c.762 0 1.385.622 1.385 1.383 0 .762-.623 1.384-1.385 1.384h-29.651a1.387 1.387 0 01-1.384-1.384c0-.761.622-1.383 1.384-1.383zM322.576 165.801h68.966a1.39 1.39 0 011.387 1.383c0 .762-.623 1.384-1.387 1.384h-68.966a1.387 1.387 0 01-1.384-1.384c0-.761.622-1.383 1.384-1.383zM322.576 173.087h68.966a1.39 1.39 0 011.387 1.384c0 .761-.623 1.383-1.387 1.383h-68.966a1.387 1.387 0 01-1.384-1.383c0-.762.622-1.384 1.384-1.384z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#538ACE"
                fillRule="evenodd"
                d="M304.9 104.828c-6.193 0-11.214 5.02-11.214 11.212 0 6.191 5.021 11.211 11.214 11.211 6.194 0 11.215-5.02 11.215-11.211 0-6.192-5.021-11.212-11.215-11.212z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M297.56 122.101a9.37 9.37 0 007.323 3.514 9.365 9.365 0 007.01-3.143c-.26-2.881-.136-4.241-3.506-6.641a4.226 4.226 0 01-3.681 2.142 4.222 4.222 0 01-3.677-2.136c-3.316 2.449-3.125 3.54-3.469 6.264z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M304.706 110.548a3.195 3.195 0 00-3.196 3.196 3.195 3.195 0 003.196 3.196 3.195 3.195 0 100-6.392z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#77A5DF"
                fillRule="evenodd"
                d="M318.105 49.44h53.477a.79.79 0 01.788.787.79.79 0 01-.788.788h-53.477a.79.79 0 01-.788-.788.79.79 0 01.788-.787z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#B7D5FF"
                d="M310.087 138.237h-11.464c-.4 0-.762.165-1.025.428h-.003a1.45 1.45 0 00-.426 1.025v11.463c0 .4.165.761.429 1.025.263.263.628.428 1.025.428h11.464a1.447 1.447 0 001.453-1.453V139.69c0-.403-.162-.764-.423-1.025h-.002a1.433 1.433 0 00-1.026-.428m-11.464-1.74h11.464c.878 0 1.674.359 2.253.938h.003a3.2 3.2 0 01.938 2.255v11.463a3.18 3.18 0 01-.938 2.255 3.185 3.185 0 01-2.256.938h-11.464a3.18 3.18 0 01-2.255-.938 3.184 3.184 0 01-.938-2.255V139.69c0-.877.359-1.673.938-2.255a3.184 3.184 0 012.255-.938z"
            ></path>
            <path
                fill="#EF8200"
                fillRule="evenodd"
                d="M302.708 147.066l5.948-5.544a1.153 1.153 0 011.625.058 1.152 1.152 0 01-.058 1.624l-6.825 6.357-.018.014a1.152 1.152 0 01-1.621-.107l-3.287-3.76a1.152 1.152 0 01.107-1.621 1.153 1.153 0 011.622.107l2.507 2.872z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#B7D5FF"
                d="M310.087 163.155h-11.464c-.4 0-.762.165-1.025.428h-.003a1.45 1.45 0 00-.426 1.025v11.463c0 .4.165.762.429 1.025.263.263.628.428 1.025.428h11.464c.402 0 .764-.162 1.025-.425.263-.266.428-.631.428-1.031v-11.463a1.45 1.45 0 00-.423-1.025h-.002a1.433 1.433 0 00-1.026-.428m-11.464-1.74h11.464c.878 0 1.674.359 2.253.938h.003a3.2 3.2 0 01.938 2.255v11.463a3.18 3.18 0 01-.938 2.255 3.185 3.185 0 01-2.256.938h-11.464a3.18 3.18 0 01-2.255-.938 3.184 3.184 0 01-.938-2.255v-11.463c0-.877.359-1.673.938-2.255a3.184 3.184 0 012.255-.938z"
            ></path>
            <path
                fill="#EF8200"
                fillRule="evenodd"
                d="M302.708 171.981l5.948-5.544a1.153 1.153 0 011.625.058 1.152 1.152 0 01-.058 1.624l-6.825 6.357-.018.015a1.153 1.153 0 01-1.621-.107l-3.287-3.761a1.152 1.152 0 01.107-1.621 1.154 1.154 0 011.622.107l2.507 2.872z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#C3E0FF"
                d="M440.204 246.961c4.815-5.022 12.555-7.28 18.764-5.361-5.653 3.792-12.316 6.015-19.274 6.172-.857.402-1.711.804-2.565 1.213 6.092-1.277 12.477 1.048 15.645 5.783-6.292.241-12.379-1.939-16.291-5.474a381.32 381.32 0 00-4.407 2.151c6.133-.59 12.153 2.322 14.901 7.327-5.809-.431-11.238-2.782-15.799-6.878-1.436.718-2.87 1.447-4.297 2.185 2.725-.442 5.496.356 7.639 1.815 2.487 1.694 4.242 4.18 5.756 6.748-5.557-.889-10.621-3.5-14.49-7.992a389.608 389.608 0 00-4.685 2.486c5.826.553 10.914 4.215 12.967 9.374-5.783-1.077-10.928-4.18-13.239-9.226a371.02 371.02 0 00-5.56 3.068c6.779.504 12.767 4.707 15.107 10.711-5.985-1.835-11.305-5.222-15.712-10.369a385.056 385.056 0 00-4.581 2.637c3.214.452 6.156 1.928 8.264 4.171 2.294 2.441 3.582 5.77 3.571 9.238-4.848-3.231-8.954-7.428-12.429-13.062-1.12.658-2.238 1.323-3.35 1.992 5.322 2.452 9.09 7.506 9.895 13.307-4.683-2.941-8.325-7.283-10.092-13.185a383.837 383.837 0 00-5.615 3.453c5.091 2.154 8.696 6.933 9.345 12.413.069.573-.168 1.433-.765 1.375-.202-.02-.356-.159-.495-.292-3.501-3.379-6.469-7.272-8.267-13.38a367.404 367.404 0 00-8.754 5.677c5.682.396 10.746 3.809 12.869 8.759-5.56-.973-10.691-3.393-13.598-8.27a341.441 341.441 0 00-5.166 3.537c5.617.099 10.502 4.172 11.299 9.489-4.963-1.482-9.293-4.449-11.577-9.295a370.307 370.307 0 00-8.065 5.798l-1.381-.301a526.053 526.053 0 016.02-4.397c-2.548-1.751-3.535-5.213-2.997-8.641 2.522 1.792 3.964 4.846 3.857 8.025a409.664 409.664 0 014.153-2.936c-2.554-3.251-3.217-7.888-2.056-12.282 2.898 2.955 3.955 7.512 2.8 11.761a408.681 408.681 0 015.655-3.859c-3.373-3.103-4.818-7.303-4.665-11.636 3.956 2.003 6.185 6.507 5.592 11.017a351.9 351.9 0 013.228-2.122c-2.238-4.982-3.529-9.709-3.964-14.595 2.215 1.852 4.312 3.948 5.36 6.64.869 2.223.901 4.93-.24 7.205a302.063 302.063 0 015.406-3.404c-3.119-4.501-4.103-9.738-2.786-14.685 3.933 3.21 5.433 8.878 3.86 14.028a305.2 305.2 0 014.726-2.825c-2.186-5.709-2.259-11.11-.443-16.078 2.076 2.09 3.31 4.953 3.446 7.984.11 2.484-.521 5.069-1.778 7.384a255.636 255.636 0 014.784-2.697c-2.178-5.205-2.08-11.116.425-16.188 3.371 4.099 3.646 10.436.843 15.496 1.5-.814 3.006-1.613 4.52-2.397-1.439-5.995-.046-12.332 3.756-17.094 2.093 5.095 1.103 11.498-2.409 16.402a227.597 227.597 0 014.803-2.374c-.353-5.789 2.615-12.143 7.694-15.921-.159 5.489-2.588 11.116-6.611 15.403a218.86 218.86 0 015.673-2.582c1.584-6.363 5.513-12.045 10.847-15.753-.77 5.734-4.222 11.341-9.144 15.015a189.79 189.79 0 014.074-1.688"
            ></path>
            <path
                fill="#C3E0FF"
                d="M362.771 240.732a98.015 98.015 0 00-3.42 14.216 66.663 66.663 0 019.726 3.821 35.545 35.545 0 00-10.169-.744c-1.309 9.946-3.073 23.167-.854 32.569 6.5-2.269 15.045-8.629 21.231-12.566a124.175 124.175 0 00-7.193-5.535 77.47 77.47 0 0110.488 3.341 107.48 107.48 0 0017.081-14.636c-3.993-2.944-8.406-5.359-12.778-7.752a58.46 58.46 0 0116.792 3.262 100.864 100.864 0 006.174-8.062c.318-.463.628-.932.944-1.407 2.478-3.749 4.612-7.35 6.454-10.974-.895-.434-1.79-.865-2.684-1.3-4.654-2.252-9.322-4.516-13.975-6.768 6.156-.385 11.704 1.584 17.826 2.415.495.066.993.141 1.485.217v-.009c3.081-7.605 5.815-17.464 7.376-27.471a36.028 36.028 0 00-3.371-.828 38.297 38.297 0 00-3.457-.568 85.632 85.632 0 013.865-1.357 76.906 76.906 0 013.53-1.063c.663-4.788 1.231-10.004 1.761-15.779-7.048 2-13.529 3.995-19.488 6.25a90.09 90.09 0 01.203 3.517c.095 2.093.115 4.186.058 6.276a44.185 44.185 0 00-2.673-4.49 49.57 49.57 0 00-2.496-3.323c-6.284 2.686-11.939 5.815-17.044 9.761.764 1.395 1.506 2.799 2.27 4.197 1.946 3.601 3.898 7.188 5.843 10.798a123.066 123.066 0 00-7.439-7.83 126.5 126.5 0 00-4.389-4.039c-3.95 3.564-7.526 7.732-10.778 12.723a89.833 89.833 0 00-5.041 8.794c1.062 1.161 2.122 2.319 3.193 3.483 2.543 2.784 5.077 5.566 7.625 8.336-3.788-1.719-7.575-3.456-11.36-5.175-.701-.316-1.393-.637-2.088-.95a98.144 98.144 0 00-3.223 8.653"
            ></path>
            <path
                fill="#A7CAFF"
                d="M417.418 198.413l-.2.243h.194c0-.078 0-.162.003-.243m-28.586 38.764l-.041.061.055-.023-.014-.038zm36.917-48.728c-.661.799-7.329 8.743-7.987 9.544a28.99 28.99 0 0110.387-.801l-.11.845a28.068 28.068 0 00-10.928 1.025l-.293.086c-1.96 2.418-3.9 4.852-5.814 7.304 5.102-.333 10.094.466 14.719 2.188.199.076.399.151.596.229l-.165.851c-.243-.095-.486-.191-.73-.281-4.749-1.768-9.888-2.536-15.13-2.078-.686.883-1.369 1.771-2.053 2.66 5.056.24 10.089 1.352 14.893 3.138.706.263 1.41.541 2.108.834-.067.281-.13.564-.197.842-.73-.31-1.465-.599-2.206-.877-4.92-1.832-10.075-2.938-15.232-3.112a518.659 518.659 0 00-4.242 5.639 93.14 93.14 0 0110.619 3.242 92.974 92.974 0 018.626 3.72c-.09.272-.183.544-.275.816a91.869 91.869 0 00-19.523-7.034 502.104 502.104 0 00-9.64 13.522 75.551 75.551 0 0114.044 3.731 73.971 73.971 0 018.864 3.98c-.133.249-.272.498-.411.747a73.154 73.154 0 00-8.751-3.928 74.906 74.906 0 00-14.279-3.755 530.833 530.833 0 00-3.665 5.422c5.968.188 11.907 1.378 17.513 3.465a55.788 55.788 0 016.718 3.02c-.148.243-.299.483-.449.726a55.004 55.004 0 00-6.565-2.947 54.404 54.404 0 00-17.75-3.424h-.023a500.017 500.017 0 00-6.77 10.479 83.977 83.977 0 0119.421 4.704 82.51 82.51 0 014.259 1.719c-.185.229-.37.458-.559.686a82.697 82.697 0 00-3.998-1.606 83.194 83.194 0 00-19.627-4.701 473.854 473.854 0 00-3.18 5.147 62.597 62.597 0 015.852 1.855 62.909 62.909 0 0113.813 7.199c-.206.206-.409.409-.614.611a61.954 61.954 0 00-19.511-8.907 529.26 529.26 0 00-3.194 5.335 46.747 46.747 0 0111.461 2.695 47.062 47.062 0 018.05 3.899c-.22.2-.44.4-.663.597a46.308 46.308 0 00-7.685-3.697 46 46 0 00-11.641-2.683 488.26 488.26 0 00-4.329 7.514c4.451.006 8.901.831 13.08 2.389a38.196 38.196 0 014.112 1.812c-.252.191-.504.382-.759.573a37.14 37.14 0 00-3.651-1.587c-4.237-1.577-8.76-2.385-13.266-2.33a517.383 517.383 0 00-4.974 9.064c2.768-.035 5.545.46 8.145 1.427.84.312 1.662.674 2.459 1.085l-.817.547a20.945 20.945 0 00-1.94-.83 21.758 21.758 0 00-8.311-1.364c-5.542 10.395-4.349 8.522-9.147 19.276h-.932c4.847-10.89 3.715-9.15 9.327-19.672-1.382-2.328-3.319-4.334-5.592-5.839l.069-.97a19.145 19.145 0 015.989 5.934c1.63-3.042 3.292-6.07 4.983-9.08a37.485 37.485 0 00-9.9-7.006l.113-.891a38.297 38.297 0 0110.222 7.127 507.429 507.429 0 014.424-7.68c-3.165-4.733-7.61-8.638-12.723-11.229.063-.287.13-.57.194-.857 5.2 2.594 9.735 6.508 13.007 11.272a523.371 523.371 0 013.107-5.193 56.826 56.826 0 00-14.8-11.133c.081-.278.162-.556.246-.834a57.765 57.765 0 0115.014 11.214 549.428 549.428 0 013.22-5.216c-4.392-5.179-9.943-9.411-16.117-12.314.098-.267.2-.536.301-.802 6.226 2.918 11.829 7.159 16.288 12.358a516.313 516.313 0 016.991-10.815c-3.061-7.55-7.848-14.428-13.862-20.012.159-.24.321-.48.484-.718 6.008 5.555 10.815 12.373 13.948 19.873a526.822 526.822 0 013.539-5.231c-3.287-7.341-7.862-14.132-13.448-19.991.185-.22.371-.437.556-.654 5.56 5.818 10.135 12.546 13.456 19.823 3.093-4.49 6.258-8.93 9.498-13.319-2.438-6.383-6.095-12.32-10.705-17.418.237-.162.475-.321.715-.48a56.56 56.56 0 0110.589 17.085 523.818 523.818 0 014.315-5.738c-1.509-5.607-4.407-10.864-8.331-15.215.261-.136.521-.272.785-.405 3.793 4.253 6.631 9.333 8.197 14.769.623-.81 1.246-1.621 1.871-2.426a45.678 45.678 0 00-7.068-13.802l.793-.365a46.504 46.504 0 016.912 13.348 507.447 507.447 0 016.452-8.099 36.9 36.9 0 00-1.338-9.941l.811-.275a37.767 37.767 0 011.369 9.179c.553-.677 7.124-8.496 7.68-9.167a.423.423 0 01.599-.058c.183.15.209.419.058.599l.009.017z"
            ></path>
            <path
                fill="#000446"
                d="M421.715 315.365H4.925v.784h416.79v-.784z"
            ></path>
            <path
                fill="#F4B1B1"
                fillRule="evenodd"
                d="M83.749 307.65l.559-5.833-5.905.139.058 6.678 5.288-.984z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#355298"
                fillRule="evenodd"
                d="M84.038 307.155c1.668 2.973 4.387 5.813 2.265 8.34H75.496a5.079 5.079 0 01-.052-.157c-.104-.347-.608-.489-.272-1.757.625-2.35 2.467-5.963 3.098-6.148 1.254-.368 3.035.669 5.765-.278"
                clipRule="evenodd"
            ></path>
            <path
                fill="#1D3975"
                fillRule="evenodd"
                d="M87.11 313.529v.006c.024.79-.057 1.488-.804 1.96H75.499c-.559-.321-.704-.541-.324-1.914l11.936-.052z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#355298"
                fillRule="evenodd"
                d="M101.847 226.799l-6.324 25.468-3.229 15.163-7.167 36.929s-1.517.686-3.94.547c-2.424-.139-3.65-.495-3.65-.495-.052-10.905-.327-25.567-.422-38.747-.084-11.59-.385-21.896-.429-30.687-.02-3.804 4.344-14.567 4.286-14.428l20.869 6.253.006-.003z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#F4B1B1"
                fillRule="evenodd"
                d="M109.839 307.65l-.023-6.033-5.902.139.634 6.878 5.291-.984z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#355298"
                fillRule="evenodd"
                d="M110.23 306.359s9.266 3.778 11.866 5.04c2.019.981 3.162 3.045 1.506 4.096h-20.203a4.748 4.748 0 01-.052-.156c-.301-.99-1.086-8.062 1.016-7.906 1.306.098 2.948.414 5.867-1.077"
                clipRule="evenodd"
            ></path>
            <path
                fill="#1D3975"
                fillRule="evenodd"
                d="M124.407 313.529v.006l.014.44c-.031.628-.286 1.181-.822 1.523h-20.296l-.052-.157c-.058-.193-.202-1.198-.272-1.757l21.431-.052-.003-.003z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#355298"
                fillRule="evenodd"
                d="M110.334 225.43c1.818 25.894 2.154 49.616.067 78.908 0 0-2.832.605-5.256.467-2.424-.139-1.981-.417-1.981-.417l-5.672-40.203s-1.283-9.153-4.286-16.289c-2.169-5.152-4.827-6.637-4.433-12.624.405-6.2-.119-11.006.741-13.148.86-2.142 5.157-1.282 5.157-1.282l15.669 4.585-.006.003z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#1D3975"
                fillRule="evenodd"
                d="M98.76 273.625l-1.271-9.075s-.701-5.031-2.273-10.56l1.201-8.603 2.496 21.571-.153 6.667z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#AEC2FD"
                fillRule="evenodd"
                d="M99.736 193.57c2.736 6.004 4.775 11.999 11.047 16.81 10.109 7.758 20.284 10.74 21.706 9.938 1.219-.689 4.601-3.031.397-5.836-2.766-2.232-13.546-11.432-16.338-13.328-.987-.671-7.335-19.198-15.952-22.341-.869-.559-3.403 10.93-.86 14.757z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#9BB3FB"
                fillRule="evenodd"
                d="M102.672 200.037c1.836 3.726 4.112 7.275 8.111 10.343 4.954 3.801 11.038 6.913 15.883 8.916-1.587-1.531-3.779-2.414-9.759-7.877-5.979-5.462-10.334-11.941-10.334-11.941l-3.904.559h.003z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#AEC2FD"
                fillRule="evenodd"
                d="M74.097 200.075c1.06 7.008 2.54 20.998 1.938 31.92 14.13 2.426 26.715 1.934 35.153-.752-1.445-11.258.808-49.935-12.043-52.978-4.645-1.299-8.253-1.183-13.175-.683-8.74.892-31.71 15.412-35.912 21.853-2.948 4.519-4.987 11.012-5.551 15.736-.209 1.745 3.874 4.464 5.956 2.631 6.59-2.46 23.191-16.978 23.634-17.727z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#9BB3FB"
                fillRule="evenodd"
                d="M74.167 200.549c1.1 7.006 2.131 22.655 1.868 31.446 12.883 2.212 24.83 2.212 33.708-.362-5.678.658-27.375 1.002-29.07-4.44-.966-3.112-1.731-21.766-3.495-30.847-1.245 1.367-2.22 2.041-3.011 4.203z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#F4B1B1"
                fillRule="evenodd"
                d="M98.937 170.759c-.994 1.978-2.062 3.422-3.614 4.166l.052 2.875.42.356c1.639 1.754-.484 3.415-2.349 3.305-7.331.362-5.032-2.188-6.257-4.217l.71-4.267c-.244-.015-2.288-1.08-2.815-1.242-.527-.162-1.3-1.178-1.353-2.249-.052-1.071 1.605-.724 1.605-.724-2.007-2.747-4.28-4.991-1.332-7.463 2.947-2.472 9.718-3.916 9.718-3.916l4.074-1.413c-.519 1.407.173 6.096 1.222 9.023.938 2.626 1.254 3.115-.081 5.769"
                clipRule="evenodd"
            ></path>
            <path
                fill="#E98385"
                fillRule="evenodd"
                d="M89.546 173.478s2.305 3.951 4.199 4.31c1.893.359.926.093 1.63.009l-.052-2.875c-1.306.209-2.58.107-5.777-1.447"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M93.447 181.459c-.87 1.01-2.404 2.628-3.273 3.638-2.287-2.119-3.483-4.154-4.676-7.115.423-.428 1.271-.903 1.694-1.332.964 1.865 2.745 3.529 6.255 4.806"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M93.446 181.458c.98.88 2.58 1.957 3.56 2.837.361-1.994.118-4.168-.525-6.464l-1.074-.582c-.078 1.613-1 2.976-1.96 4.209z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#F4B1B1"
                d="M59.512 226.301l3.68 30.445-3.3 50.603c.11.15.22.301.33.446.083.116.167.226.254.336.203.266.403.518.603.755.09.107.18.211.272.313 1.488 1.638 3.408 2.035 4.983 2.417 1.22.298 2.157.443 2.986 2.072a.93.93 0 01-.854 1.341l-14.444-.452a1.392 1.392 0 01-1.352-1.531l.964-6.302s0-.009.003-.026c-.35-12.303-3.136-30.334-.855-44.707 0 0-2.808-15.582-2.753-16.24.055-.651 9.477-19.467 9.477-19.467M47.576 251.329c-.628 5.416 3.15 8.63 2.525 14.046-.009 13.559-9.512 29.179-12.727 42.871-.107.455.704 4.759.611 5.208-1.427 1.525-5.495 3.679-5.93-3.358 1.819-11.822 4.083-30.928 8.765-45.309l-2.956-14.338 9.715.88h-.003z"
            ></path>
            <path
                fill="#355298"
                fillRule="evenodd"
                d="M67.753 222.541c1.468 8.618.669 30.653-.953 47.683-11.73 3.01-28.991 2.194-33.303-1.448 2.879-22.211 4.34-43.554 8.94-47.486 4.87-5.78 23.897-4.495 25.316 1.251z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M46.143 186.982s.782 8.823 2.652 19.913c1.87 11.087-.559 15.536-.559 15.536l14.595-.347s-.953-12.949-2.534-20.88c-1.581-7.932-3.38-15.855-3.38-15.855l-3.88.593-6.683-.11-.214 1.147.003.003z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#F4B1B1"
                fillRule="evenodd"
                d="M55.71 190.893c3.91-.964 3.643-2.727 3.643-2.727l-4.187-3.729-9.573.767-.574 3.746 1.34 2.053c3.22-.087 5.445.854 9.354-.11"
                clipRule="evenodd"
            ></path>
            <path
                fill="#FFBC4A"
                d="M36.303 186.348c-2.76 11.252 8.708 25.836 1.923 42.359 3.7.515 9.443 1.965 13.879 1.3.533-2.791 2.32-7.585 1.15-21.144-1.173-13.559-6.947-23.343-6.947-23.343l1.091.205 5.088.11 2.954-.593s3.225 8.571 4.323 15.8c1.097 7.228.927 25.227 1.181 29.338 3.585-.258 9.941.515 8.815-2.828-.831-2.469-2.994-13.733-3.078-17.412-.145-6.597 1.639-9.527.518-13.357-1.24-4.235-4.627-11.278-6.741-12.137-9.982-2.797-20.05-4.421-24.159 1.705"
            ></path>
            <path
                fill="#EF7E05"
                d="M62.413 228.148c1.06 3.645 8.653 2.22 7.35-.596-.634-1.372-1.938-8.708-2.522-12.248-.701 5.022-5.693 10.187-4.828 12.844z"
            ></path>
            <path
                fill="#E69A1A"
                d="M37.053 200.729c2.186 5.624 4.106 12.954 2.708 25.659 1.224.171 8.915 3.413 10.236 3.54.787-2.848-4.581-4.84-7.338-9.144-.04-.599-.197-1.621-.249-2.226-.625-7.448-1.96-15.137-3.99-20.565l-1.367 2.733v.003z"
            ></path>
            <path
                fill="#F4B1B1"
                fillRule="evenodd"
                d="M54.418 180.963l.05 2.73.396.339c1.555 1.667-.127 5.089-1.9 4.982a7.809 7.809 0 01-4.583-1.213c-1.865-1.201-2.803-3.025-1.99-4.232l.586-.652.13-3.861c-.232-.012-1.914-.97-2.415-1.123-.501-.154-1.237-1.118-1.286-2.137-.05-1.019 1.526-.689 1.526-.689-1.908-2.608-4.065-4.738-1.265-7.089 2.8-2.351 9.231-3.72 9.231-3.72l3.872-1.34c-.493 1.334.165 5.789 1.16 8.571 1.414 3.955.63 7.454-3.509 9.437"
                clipRule="evenodd"
            ></path>
            <path
                fill="#E98385"
                fillRule="evenodd"
                d="M48.931 179.591s2.19 3.755 3.988 4.094c1.798.338.88.089 1.549.008l-.05-2.73c-1.239.2-2.452.102-5.487-1.375"
                clipRule="evenodd"
            ></path>
            <path
                fill="#FFBC4A"
                d="M37.566 185.311c-9.933 4.117-11.195 25.495-9.16 31.605 1.712 4.956 14.78 18.09 19.043 16.307 2.056-.86 4.04-3.674.944-5.68-4.52-2-11.018-11.582-11.279-12.815-1.225-9.113 6.072-30.305.449-29.417"
            ></path>
            <path
                fill="#F4B1B1"
                fillRule="evenodd"
                d="M48.775 229.074l1.755.97c.538.009 8.238-.353 7.019.68-.707.597-2.682 1.422-2.656 1.509.365 1.129 4.251 1.331 4.289 1.432.538 1.445-3.081.799-3.686.579-.16-.057 2.516 1.014 2.25 1.344-.513.639-2.392-.319-3.284-.423-.217-.026 2.247.909 2.035 1.349-.723.411-2.652-.567-3.188-.643-.127-.017 1.938.903 2.097 1.181.133.238-.267.478-.556.38-4.271-1.422-2.844-2.878-7.778-4.374-2.745-.834.116-4.603 1.697-3.984"
                clipRule="evenodd"
            ></path>
            <path
                fill="#355298"
                fillRule="evenodd"
                d="M49.545 170.424s5.557.188 7.627-1.607c4.344-3.731 1.7-12.63-9.402-9.336-8.835 2.623-4.512 11.296-16.007 14.885-4.26 1.332-3.753 3.465-.015 4.913-2.55.9-.084 3.395 2.273 3.097-4.497 3.601 5.239 6.403 12.373 1.193 4.104-3.008-3.11-12.208 3.154-13.145M65.891 311.147s5.03 1.392 4.804 2.941c-.457 3.129-17.719 1.062-17.811.95-.611-.762-.684-4.293.139-5.347.614-.785 5.617 3.873 12.868 1.456zM39.57 315.642c-.11 2.009-7.535 1.358-8.627.756-1.624-.897.275-5.289 1.132-6.441 2.375 4.912 5.314 1.552 5.876 1.76.715 1.413 1.72 2.073 1.621 3.925"
                clipRule="evenodd"
            ></path>
            <path
                fill="#FFBC4A"
                fillRule="evenodd"
                d="M58.177 184.753c11.044-1.352 18.428 17.406 19.71 23.945.986 5.335-6.984 20.782-11.73 21.346-1.106.13-3.972-1.89-2.617-4.49 3.052-4.102 6.211-12.583 5.814-13.822-1.358-3.384-3.648-5.387-6.425-7.089-2.018-1.239-1.303-5.796-2.693-10.225-1.37-4.368-4.88-8.609-2.059-9.665z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#E69A1A"
                fillRule="evenodd"
                d="M69.042 210.976c-.287-.558-2.022-2.26-2.346-2.747.177-5.297 1.514-8.01.51-11.451-.773-2.643-2.383-6.381-4.002-9.026 1.89 2.559 3.999 7.257 4.92 10.403 1.019 3.483 1.068 7.399.918 12.821z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#F4B1B1"
                fillRule="evenodd"
                d="M63.531 226.799l-1.118 1.349c-.434.18-6.81 2.354-5.49 2.802.765.258 2.638.295 2.641.374.067 1.036-3.466 4.895-3.463 4.987.026 1.346 2.41-.972 2.832-1.346.11-.098-1.294 1.575-1.147 1.986.058.159.611.125 1.066-.301.559-.521 1.37-1.569 1.555-1.557.19.011-1.263 1.696-1 1.997.166.182.42 0 .762-.333.565-.556 1.254-1.572 1.457-1.609.205-.038-1.002 1.537-.976 1.728.035.252.319.159.428.063 3.018-2.527 1.628-4.165 5.16-6.964 1.964-1.558-1.54-4.348-2.71-3.182M135.298 216.656c.816-.2 4.059-.952 4.804-.669.379.145.295.264.191.458-.09.17-.429.437-.704.532-.573.197-1.326 1.002-1.656 1.063 1.442 3.149 6.008 4.446 4.986 5.963-.342.136-2.493.182-3.043.339-1.749.5-2.667.561-7.874-3.955-1.76-1.525-.133-3.169 1.277-4.009l2.016.281.003-.003z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#355298"
                fillRule="evenodd"
                d="M97.442 161.218c-3.486 1.954-7.662-.052-9.642 2.464-.979 1.245-.811 2.981.437 5.627.368.779.843 1.346-.518.776-.626-.261-1.65-.62-1.987-.33-.747.651-.31 1.942.322 2.339.28.177.81.437.81.437-9.26-.57-13.444-21.806 6.938-20.191.577.046.18-1.624.78-1.644 4.578-.171 8.646 6.884 2.86 10.522z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#3D7DDA"
                d="M193.909 140.457H172.33v38.156h21.579v-38.156z"
            ></path>
            <path
                fill="#1A60C8"
                fillRule="evenodd"
                d="M217.022 134.754h91.964l81.099 69.475h-159.96c0 20.063-13.103-60.165-13.103-69.475z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#DF9400"
                d="M381.543 204.229h-96.846v111.089h96.846V204.229z"
            ></path>
            <path
                fill="#3D7DDA"
                fillRule="evenodd"
                d="M390.085 204.229H276.511l8.189 4.035h105.388v-4.035h-.003zm-231.949-3.758l-19.456 3.758v4.035h10.668l8.788-7.796v.003zm-19.456 3.758l78.342-69.475 78.343 69.475h-18.857l-4.613-3.758H158.136l-19.456 3.758z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#FFBC4A"
                fillRule="evenodd"
                d="M284.697 208.267v107.054H149.348V208.267l67.674-60.017 67.675 60.017z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#DE7405"
                fillRule="evenodd"
                d="M214.645 213.448h24.535l2.126 2.189v99.684h-24.533l-2.128-2.188v-99.685z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M194.868 309.407v-95.959h44.312v101.873h-44.312v-5.914z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#024BC8"
                d="M236.116 216.338h-38.185v93.231h38.185v-93.231z"
            ></path>
            <path
                fill="#DE7405"
                fillRule="evenodd"
                d="M249.283 213.666h24.532l2.129 2.061v54.32h-24.533l-2.128-2.064v-54.317z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M273.815 213.666h-24.532v54.317h24.532v-54.317z"
            ></path>
            <path
                fill="#105DC4"
                d="M270.755 216.725h-18.408v48.192h18.408v-48.192z"
            ></path>
            <path
                fill="#DE7405"
                fillRule="evenodd"
                d="M159.734 213.666h24.532l2.129 2.061v54.32h-24.532l-2.129-2.064v-54.317z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M184.266 213.666h-24.532v54.317h24.532v-54.317z"
            ></path>
            <path
                fill="#105DC4"
                d="M181.203 216.725h-18.405v48.192h18.405v-48.192zM236.116 216.338h-38.185v93.231h38.185v-93.231z"
            ></path>
            <path
                fill="#B9E4FF"
                d="M232.653 218.619H201.29v27.862h31.363v-27.862z"
            ></path>
            <path
                fill="#B9E4FF"
                fillRule="evenodd"
                d="M232.653 279.441v27.862H201.29V248.935h31.363v30.506z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#C8EDFD"
                fillRule="evenodd"
                d="M252.347 240.633l18.405-19.088v4.143l-18.405 19.085v-4.14zM252.347 248.301l18.405-19.088v7.614l-18.405 19.085v-7.611zM162.798 240.633l18.408-19.088v4.143l-18.408 19.085v-4.14zM162.798 248.301l18.408-19.088v7.614l-18.408 19.085v-7.611z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#DE7405"
                fillRule="evenodd"
                d="M194.868 177.076h44.312l2.125 2.064v27.075h-44.309l-2.128-2.064v-27.075z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M239.18 177.076h-44.312v27.075h44.312v-27.075z"
            ></path>
            <path
                fill="#105DC4"
                d="M236.056 180.196h-38.067v20.834h38.067v-20.834z"
            ></path>
            <path
                fill="#CD6615"
                fillRule="evenodd"
                d="M299.332 213.666h24.532l2.129 2.061v54.32H301.46l-2.128-2.064v-54.317z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M323.864 213.666h-24.532v54.317h24.532v-54.317z"
            ></path>
            <path
                fill="#105DC4"
                d="M320.801 216.725h-18.405v48.192h18.405v-48.192z"
            ></path>
            <path
                fill="#C8EDFD"
                fillRule="evenodd"
                d="M302.396 240.633l18.405-19.088v4.143l-18.405 19.085v-4.14zM302.396 248.301l18.405-19.088v7.614l-18.405 19.085v-7.611z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#3D7DDA"
                d="M195.276 134.754h-24.489v8.601h24.489v-8.601z"
            ></path>
            <path
                fill="#C8EDFD"
                fillRule="evenodd"
                d="M197.989 201.03l19.876-20.834h3.95l-19.876 20.834h-3.95zM205.304 201.03l19.876-20.834h7.259l-19.873 20.834h-7.262z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#CD6615"
                fillRule="evenodd"
                d="M338.496 213.666h24.535l2.126 2.061v54.32h-24.533l-2.128-2.064v-54.317z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M363.028 213.666h-24.532v54.317h24.532v-54.317z"
            ></path>
            <path
                fill="#105DC4"
                d="M359.965 216.725H341.56v48.192h18.405v-48.192z"
            ></path>
            <path
                fill="#C8EDFD"
                fillRule="evenodd"
                d="M341.56 240.633l18.408-19.088v4.143l-18.408 19.085v-4.14zM341.56 248.301l18.408-19.088v7.614l-18.408 19.085v-7.611z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default MainImg;
